(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apollo-home"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-apollo-comparison]');

    roots.forEach((root) => {
      const toggle = root.querySelector('[data-apollo-toggle]');
      const label = root.querySelector('[data-apollo-toggle-label]');

      if (!toggle || !label) return;

      toggle.addEventListener('click', () => {
        const update = () => {
          const isGlow = root.classList.toggle('is-glow');
          toggle.setAttribute('aria-pressed', String(isGlow));
          label.textContent = isGlow ? toggle.dataset.dayLabel : toggle.dataset.nightLabel;
        };

        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
      });
    });

    const reveals = document.querySelectorAll('.apollo-reveal');

    if (!('IntersectionObserver' in window)) {
      reveals.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    reveals.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rune-afterdark-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const poster = event.target.closest('[data-rune-video-id]');

    if (!poster) {
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + poster.dataset.runeVideoId + '?autoplay=1&rel=0&modestbranding=1';
    iframe.title = 'Rune Refinery Super Lume jewelry video';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    poster.replaceWith(iframe);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rune-collection-lander"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const poster = event.target.closest('[data-rune-collection-video-id]');

    if (!poster) {
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + poster.dataset.runeCollectionVideoId + '?autoplay=1&rel=0&modestbranding=1';
    iframe.title = poster.getAttribute('aria-label');
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    poster.replaceWith(iframe);
  });

  } catch(e) { console.error(e); }
})();
})();
